export default {
  appName: 'Badpa',
  appTagline: 'Driver dashboard'
}
